import type { UserPublic } from '@connexio/shared';

type RedirectUser = Pick<UserPublic, 'platformRole'> | null | undefined;

/** Default landing route after login or an authenticated visit to `/`. */
export function getDefaultAppPath(user: RedirectUser, hasActiveOrg: boolean): string {
  if (user?.platformRole === 'SUPER_ADMIN' && !hasActiveOrg) {
    return '/platform-admin/licenses';
  }
  if (!hasActiveOrg) {
    return '/select-organization';
  }
  return '/dashboard';
}

/** Safe in-app redirect target with platform-admin fallback when no tenant org exists. */
export function resolvePostLoginPath(
  redirectTo: string | null | undefined,
  user: RedirectUser,
  hasActiveOrg: boolean,
): string {
  const fallback = getDefaultAppPath(user, hasActiveOrg);
  if (!redirectTo || !redirectTo.startsWith('/') || redirectTo.startsWith('//')) {
    return fallback;
  }
  return redirectTo;
}
